type ReducerState = {
  recordsCount: number;
  completedRecordsCount: number;
};

type ActionType = "Reset" | "Initialize" | "AddRecord" | "CompleteRecord";

type ReducerAction =
  | {
      type: "Initialize" | "AddRecord";
      param?: number;
    }
  | {
      type: "Reset" | "CompleteRecord";
    };

function uploadStateHandler(
  state: ReducerState,
  action: ReducerAction
): ReducerState {
  const { type } = action;
  switch (type) {
    case "Reset":
      return {
        recordsCount: 0,
        completedRecordsCount: 0,
      };
    case "Initialize":
      return {
        recordsCount: action.param,
        completedRecordsCount: 0,
      };
    case "AddRecord":
      return {
        ...state,
        recordsCount: state.recordsCount + action.param,
      };
    case "CompleteRecord":
      return {
        ...state,
        completedRecordsCount: state.completedRecordsCount + 1,
      };
    default:
      return state;
  }
}

const uploadStateInitialize: ReducerState = {
  recordsCount: 0,
  completedRecordsCount: 0,
};

export { uploadStateHandler, uploadStateInitialize };

export type { ReducerAction, ReducerState, ActionType };
